import CareerHistories from "../models/CareerHistories";
import { CareerHistoryResponseModel } from "../services/openApi/api";
import ApiService from "./ApiService";
import Utils from "../utils/Utils";
import { SystemErrors } from "../definitions/systemErrors";
import moment from "moment";

export default class CareerHistoryService {
  public static getCareerHistories(teammemberId = ""): Promise<CareerHistories[] | null> {
    return new Promise((resolve, reject) => {
      var path = "";
      var param = "";
      if (teammemberId) {
        param = `/${teammemberId}`;
        path = "/admin";
      }
      ApiService.get(`${path}/teammember/careerHistories${param}`, "")
        .then((res) => {
          if (!res.data || res.data.statusCode != SystemErrors.Authentication.Success || !res.data.value) {
            resolve(null);
          } else {
            resolve(this.getCareerHistoryFromResponse(res.data.value));
          }
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  public static async set(model: CareerHistories, teammemberId = ""): Promise<CareerHistoryResponseModel> {
    return new Promise((resolve, reject) => {
      var path = "";
      var param = "";
      if (teammemberId) {
        param = `/${teammemberId}`;
        path = "/admin";
      }
      ApiService.post(`${path}/teammember/saveCareerHistory${param}`, { careerHistory: model })
        .then((res) => {
          if (!res.data || res.data.statusCode != SystemErrors.Authentication.Success || !res.data.value) {
            resolve({} as CareerHistoryResponseModel);
          } else {
            var retval = res.data.value;
            retval.CareerHistoryModel = this.getCareerHistoryFromResponse(retval.CareerHistoryModel);
            resolve(retval);
          }
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  public static async saveCareerHistoryDescription(description: string, teammemberId = ""): Promise<string> {
    return new Promise((resolve, reject) => {
      var path = "";
      var param = "";
      if (teammemberId) {
        param = `/${teammemberId}`;
        path = "/admin";
      }
      if (description == null) {
        description = "";
      }
      ApiService.post(`${path}/teammember/saveCareerHistoryDescription${param}`, { description: description })
        .then((res) => {
          if (!res.data || res.data.statusCode != SystemErrors.Authentication.Success || !res.data.value) {
            resolve("");
          } else {
            resolve(res.data.value);
          }
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  public static sendAddRequest(jobName: any): Promise<boolean> {
    return new Promise((resolve, reject) => {
      ApiService.get(`/teammember/jobrequest/${jobName}`, "")
        .then((result) => {
          if (!result.data || result.data.statusCode != SystemErrors.Authentication.Success || !result.data.value) {
            resolve(false);
          } else {
            resolve(result.data.value);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  public static async delete(id: any, teammemberId = ""): Promise<CareerHistories[]> {
    return new Promise((resolve, reject) => {
      var path = "";
      var param = "";
      if (teammemberId) {
        param = `/${teammemberId}`;
        path = "/admin";
      }
      ApiService.delete(`${path}/teammember/removeCareerHistory/${id}${param}`)
        .then((res) => {
          if (!res.data || res.data.statusCode != SystemErrors.Authentication.Success || !res.data.value) {
            resolve([] as CareerHistories[]);
          } else {
            const retVal = this.getCareerHistoryFromResponse(res.data.value);
            resolve(retVal);
          }
        })
        .catch((err) => {
          reject(err);
        });
    });
  }
  private static getCareerHistoryFromResponse(list: CareerHistories[]) {
    const retVal = list.map((doc) => {
      const item = { id: doc.Id, ...doc } as CareerHistories;
      if (item.EndDate && doc.EndDate) {
        item.EndDate = moment(doc.EndDate).toDate();
      }
      if (item.StartDate) {
        item.StartDate = moment(doc.StartDate).toDate();
      }
      return item;
    });

    return retVal;
  }
}
